var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-ajax-dropdown',{attrs:{"url":`/api/metrics`,"value":_vm.selectedResources,"placeholder":_vm.placeholder,"query":_vm.query,"blacklist":_vm.blacklist,"disabled":_vm.isLoading,"label":"name","trackBy":"id","allowEmpty":true,"multiple":true},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }